import React from 'react';

export const PhotoModeContext = React.createContext({
  isPhotoMode: false,
  setIsPhotoMode: () => {},
  jobType: null,
  setJobType: () => {}
});
